<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputName" });
import { InputText } from "../../../../inputs/index.js";
export let value = {};
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = true;
const MIN_LENGTH = 2;
</script>

<fieldset class = 's8-input-name'>
    <InputText
        bind:value = { value.first }
        autocomplete = 'given-name'
        label = 'resource.user.properties.name.first.label'
        name = 'user.name.first'
        placeholder = 'resource.user.properties.name.first.placeholder'
        minLength = { MIN_LENGTH }
        { isDisabled }
        { isReadonly }
        { isRequired }
    />
    <InputText
        bind:value = { value.last }
        autocomplete = 'family-name'
        label = 'resource.user.properties.name.last.label'
        name = 'user.name.last'
        placeholder = 'resource.user.properties.name.last.placeholder'
        minLength = { MIN_LENGTH }
        { isDisabled }
        { isReadonly }
        { isRequired }
    />
</fieldset>

<style>
    fieldset.s8-input-name {
        display: flex;
        -moz-column-gap: 20px;
             column-gap: 20px;
    }</style>